import { mapGetters } from "vuex";
import baseMixin from "~/mixins/base";
import {
    exportCSVFile,
    adapterHeadersAsJsonFromTableFields,
    adapterTableItemsFromHeaders,
} from "~/helpers/table";

import { QueryBuilder } from "~/utils/queryBuilder.js";
import { getValueByPath } from "~/utils";
import { setValueByPath } from "../utils";

const FilterOptions = {
    contains: "like",
    not_contains: "not_like",
    is_equal_to: "equal",
    is_not_equal_to: "not_equal",
    is_in_list: "in",
    regexp: "regexp",
    not_in_list: "not_in",
    not_regexp: "not_regexp",
};

export default {
    mixins: [baseMixin],
    data() {
        return {
            FilterOptions,
        };
    },

    computed: {
        ...mapGetters({
            storePageTables: "page/tables",
            storeFrom: "filter/from",
            storeTo: "filter/to",
            storeGlobalCountries: "global/countries",
        }),
    },

    directives: {
        export: {
            // Definición de directiva
            bind: function (el) {
                let table = el.querySelector("table");
                table.setAttribute("export", true);
            },
        },
    },
    methods: {
        async actionSelectAllItems(tableName) {
            this.tables[tableName].items.forEach((item) => {
                item._selected = true;
            });
        },
        cleanMessageToExport({ table }) {
            for (const property in table.items) {
                var message = table.items[property].message;
                table.items[property].message = message.replace(/,/g, " ");
            }
            return table;
        },
        cleanCampanyTypeExport({ table }) {
            for (const property in table.items) {
                var CampanyType = table.items[property].CampanyType;
                table.items[property].CampanyType = CampanyType.replace(
                    /,/g,
                    " "
                );
            }
            return table;
        },
        cleanElementTypeExport({ table }, name) {
            for (const property in table.items) {
                var element = table.items[property][name];
                if (element.search(/"/)) {
                    table.items[property][name] =
                        "'" + table.items[property][name] + "'";
                }
            }
            return table;
        },
        cleanElementTableTypeExport(testTable, name) {
            for (const property in testTable.items) {
                var element = testTable.items[property][name];
                if (element.search(/"/)) {
                    testTable.items[property][name] =
                        "'" + testTable.items[property][name] + "'";
                }
            }
            return testTable;
        },

        resetFiltersInTable({
            tableName,
        }){
            this.cleanFiltersAdvance(tableName);
        },


        cleanFiltersAdvance(tableName) {
            this.tables[tableName].columnFilterValue = {};
            var fields = this.tables[tableName].fields;
            fields.map((field) => {
                if (field._filter) {
                    field._filter.active = false;
                    field._filter.value = "";
                }
            });
            this.tables[tableName].fields = fields;
        },
        //Return primer nombre de tabla
        getTableName() {
            if (Object.keys(this.tables)[0]) {
                return Object.keys(this.tables)[0];
            }
            return null;
        },

        itemPerPage(newValue) {
            let defaultTableName = this.getTableName();
            this.tables[defaultTableName].rows = newValue;
            this.updatePagination(
                this.tables[defaultTableName]["page"]
            );
        },
        updatePagination(newValue) {
            let defaultTableName = this.getTableName();
            this.tables[defaultTableName]["page"] = newValue;
            this.updateData();
        },

        downloadExportTable({ tableName, fileName }) {
            tableName = this.getTableName();
            let table = this.tables[tableName];
            if (table.items.length > 0) {
                if (table.items[0].hasOwnProperty("message")) {
                    table = this.cleanMessageToExport({ table });
                }
                if (table.items[0].hasOwnProperty("CampanyType")) {
                    table = this.cleanCampanyTypeExport({ table });
                }
                if (table.items[0].hasOwnProperty("request_report")) {
                    table = this.cleanElementTypeExport(
                        { table },
                        "request_report"
                    );
                }
                if (table.items[0].hasOwnProperty("response")) {
                    table = this.cleanElementTypeExport({ table }, "response");
                }
            }
            let headers = adapterHeadersAsJsonFromTableFields(table.fields);
            for (const key in table.fields) {
                if (
                    !table.fields[key]._import &&
                    table.fields[key]._import == false
                ) {
                    delete headers[table.fields[key].key];
                }
            }
            let items = adapterTableItemsFromHeaders(table.items, headers);
            exportCSVFile({ headers, items, fileName });
            return true;
        },
        getStoreTable(tableName) {
            if (!this.storePageTables) {
                throw new Error("Store tables not found");
            }
            let find = this.storePageTables.find(
                (table) => table.name === tableName
            );
            if (!find) {
                throw new Error("Table not found");
            }
            return find;
        },
        getTableAllFields(tableName) {
            return this.getStoreTable(tableName).allFields;
        },
        getTableField(tableName, fieldKey) {
            let findIndex = this.tables[tableName].fields.findIndex(
                (field) => field.key === fieldKey
            );
            if (findIndex === -1) {
                throw new Error("Field not found");
            }
            return this.tables[tableName].fields[findIndex];
        },
        setTableField(tableName, fieldKey, value) {
            let findIndex = this.tables[tableName].fields.findIndex(
                (field) => field.key === fieldKey
            );
            if (findIndex === -1) {
                throw new Error("Field not found");
            }
            this.tables[tableName].fields[findIndex] = value;
        },
        getDefaultTableItem(tableName, defaultValue = null) {
            let item = {};

            this.tables[tableName].fields.forEach((field) => {
                if (typeof field === "string" && field !== "options")
                    this.$set(item, field, defaultValue);
                else if (field.key && field.key != "options")
                    if (field._defaultValue) {
                        this.$set(item, field.key, field._defaultValue);
                    } else {
                        this.$set(item, field.key, defaultValue);
                    }
            });
            return item;
        },

        addItemToTable(tableName, defaultValue = null, defaultItem = null) {
            defaultItem = !defaultItem
                ? this.getDefaultTableItem(tableName, defaultValue)
                : structuredClone(defaultItem);
            let items = this.tables[tableName].items;
            items.push(defaultItem);
            this.$set(this.tables[tableName], "items", items);
            return {
                item: defaultItem,
                index: this.tables[tableName].items.length - 1,
            };
        },
        deleteItemToTable(tableName, index) {
            this.tables[tableName].items.splice(index, 1);
        },
        deleteItemToSubTable(tableName, subTableName, index, subIndex) {
            this.tables[tableName].items[index][subTableName].splice(
                subIndex,
                1
            );
        },
        moveFieldMappingUp(index) {
            let items = [...this.tables.fieldMapping.items];

            let item = this.tables.fieldMapping.items[index];
            let temp = items[index - 1];
            items[index - 1] = item;
            items[index] = temp;
            this.tables.fieldMapping.items = items;
        },
        moveFieldMappingDown(index) {
            let items = [...this.tables.fieldMapping.items];

            let item = this.tables.fieldMapping.items[index];
            let temp = items[index + 1];
            items[index + 1] = item;
            items[index] = temp;
            this.tables.fieldMapping.items = items;
        },

        createQuery({ order, where, columnFilterValue = {} }) {
            let query = {
                where,
                order,
            };
            if ("storeFilterAdvance" in columnFilterValue) {
                let filterAdvance = columnFilterValue.storeFilterAdvance;
                for (const key in filterAdvance) {
                    if (filterAdvance[key].value !== "") {
                        if (filterAdvance[key].condition == "contains") {
                            query.where[key] = {
                                like: `%${filterAdvance[key].value}%`,
                            };
                        } else {
                            query.where[key] = {
                                [FilterOptions[
                                    filterAdvance[key].condition
                                ]]: `${filterAdvance[key].value}`,
                            };
                        }
                    }
                }
            }

            for (const key in columnFilterValue) {
                if (
                    key != "storeFilterAdvance" &&
                    columnFilterValue[key] !== ""
                ) {
                    query.where[key] = {
                        like: `%${columnFilterValue[key]}%`,
                    };
                }
            }

            if (!query.where) {
                delete query.where;
            }
            for (const key in query.order) {
                if (Object.hasOwnProperty.call(query.order, key)) {
                    const orderElement = query.order[key];
                    if (!orderElement) {
                        delete query.order[key];
                    }
                }
            }
            if (!query.order || JSON.stringify(query.order) === "{}") {
                delete query.order;
            }

            return query;
        },

        selectItemTable(tableName, item) {
            this.tables[tableName].itemSelected = item;
        },

        /**
         * @param {*} object { tableName }
         * @returns {boolean}
         * @description Si la tabla esta en el store, revisa si tiene tiene items cargados.
         */
        hasItemsInTable({ tableName }) {
            // let findTable = this.storePageTables.find(table => table.name == tableName);
            let findTable = this.tables[tableName];
            if (findTable.items.length > 0) {
                return true;
            }
            if (
                (findTable.items.length == 0 && !findTable.loading) ||
                findTable.loading === undefined
            ) {
                return false;
            }
            return true;
        },
        hasFiltersInTable({ tableName }) {
            var fields = this.tables[tableName].fields;
            var filtersValue = this.tables[tableName].columnFilterValue;
            var filter = false;
            fields.map((field) => {
                if (field._filter && !filter) {
                    filter = field._filter.active;
                }
            });
            for (const property in filtersValue) {
                if (property != "storeFilterAdvance") {
                    filter = true;
                }
            }
            return filter;
        },
        async loadCountryInItems({ table, fielCountryName = "country_id" }) {
            let countries = this.storeGlobalCountries;
            if (Array.isArray(countries)) {
                for (let i = 0; i < table.items.length; i++) {
                    let countryFind = countries.find(
                        (country) => country.id == table.items[i].country_id
                    );
                    if (countryFind) {
                        table.items[i][fielCountryName] = countryFind.name;
                    }
                }
            }
            return table.items;
        },
        selectItemTable(tableName, itemId) {
            this.tables[tableName].itemSelected = itemId;
        },
        async downloadAllTable({
            tableName,
            url,
            adapterFilters,
            delimiter,
            stringDelimiter,
            baseURL,
            queryParams,
        }) {
            tableName = this.getTableName();
            let fileName = "allExport";
            let testTable = new Object();
            const separator = delimiter || ",";
            const quote = stringDelimiter || "'";

            testTable.fields = this.tables[tableName].fields;
            testTable.rows = this.tables[tableName].rows;
            testTable.page = this.tables[tableName].page;
            testTable.columnFilterValue =
                this.tables[tableName].columnFilterValue;
            testTable.order = this.tables[tableName].order;
            testTable.dateFieldFilter = this.tables[tableName].dateFieldFilter;
            testTable.orderField = this.tables[tableName].orderField;
            testTable.matchResponseCurrentPage = this.tables[tableName].matchResponseCurrentPage;
            testTable.matchResponsePages = this.tables[tableName].matchResponsePages;
            testTable.matchResponse = this.tables[tableName].matchResponse;

            testTable = await this.loadTable({
                table: testTable,
                baseURL: baseURL,
                url,
                adapterFilters,
                queryParams,
                pagination: false,
            });

            testTable.items = await this.loadCountryInItems({
                table: testTable,
            });

            if (testTable.items.length > 0) {
                let hasFieldId = testTable.fields.find((field) => {
                    return field.key == "id";
                });

                testTable.items = testTable.items.map((item, index) => {
                    if (hasFieldId && !item.hasOwnProperty("id")) {
                        item = {
                            ...item,
                            id: index + 1,
                        };
                    }
                    // for (const key in item) {
                    //     console.log({key, value: item[key], separator});
                    //     if (
                    //         this.isString(item[key]) &&
                    //         item[key].includes(separator)
                    //     ) {
                    //         item[key] = `${quote}${item[key]}${quote}`;
                    //     }
                    // }
                    return item;
                });
            }
            let headers = adapterHeadersAsJsonFromTableFields(testTable.fields);
            for (const key in testTable.fields) {
                if (
                    testTable.fields[key].hasOwnProperty("_import") &&
                    testTable.fields[key]._import == false
                ) {
                    delete headers[testTable.fields[key].key];
                }
            }
            let items = adapterTableItemsFromHeaders(testTable.items, headers);
            exportCSVFile({
                headers,
                items,
                fileName,
                delimiter: separator,
                stringDelimiter: quote,
            });
        },

        async updateTable({
            tableName,
            url,
            fetch,
            customFields,
            adapterFilters,
            adapterData,
            baseURL,
            queryParams
        }) {
            this.tables[tableName].loading = true;
            let updateTable = this.tables[tableName];

            updateTable = await this.loadTable({
                table: updateTable,
                url,
                fetch,
                customFields,
                adapterFilters,
                adapterData,
                baseURL,
                queryParams
            });
            await this.$store.dispatch("page/updateTables", {
                ...updateTable,
                name: tableName,
                allFields: this.getTableFieldsFromFirstItem({ tableName }),
            });
            updateTable.allFields = this.getStoreTableFields(tableName);

            this.tables[tableName] = updateTable;

            this.tables[tableName].loading = false;
        },

        async loadTable({
            table,
            url,
            fetch,
            method = "GET",
            customFields,
            adapterFilters,
            adapterData,
            pagination = true,
            baseURL,
            /**
             * Params sueltos que se mandan junto a `query`/`rows`/`page`, para
             * endpoints que esperan algo fuera del `query` (por ejemplo los
             * `stats_from`/`stats_to` del listado de balanceadores).
             */
            queryParams = {}
        }) {
            let from = this.storeFrom;
            let to = this.storeTo;
            let rows = table.rows;
            let columnFilterValue = table.columnFilterValue;
            var storeFilterAdvance = {};
            let order = table.order;
            let orderField = table.orderField || "created_at";
            let matchResponse = table.matchResponse || "_items";
            let dateFieldFilter = table.dateFieldFilter || "created_at";
            let matchResponsePages = table.matchResponsePages || "total_pages";
            let page = table.page;
            // Legacy order
            order = {
                [orderField]: order,
            };

            if (table.sorterValue && table.sorterValue.column) {
                order = {
                    [table.sorterValue.column]: table.sorterValue.asc
                        ? "asc"
                        : "desc",
                };
            }

            // Mapear aqui el filtro advance _filter
            table.fields.map((item) => {
                if (
                    item._filter &&
                    item._filter.active &&
                    item._filter.value != null
                ) {
                    storeFilterAdvance[item.key] = {
                        condition: item._filter.condition,
                        value: item._filter.value,
                    };
                }
            });
            columnFilterValue.storeFilterAdvance = storeFilterAdvance;
            /** Create table filter */
            if (dateFieldFilter == "date") {
                from = from.split(" ")[0];
                to = to.split(" ")[0];
            }
            let tableFilter = this.createQuery({
                where: {
                    [dateFieldFilter]: {
                        between: [from, to, false],
                    },
                },
                order,
                columnFilterValue,
            });

            // Check is function

            if (adapterFilters && typeof adapterFilters === "function") {
                tableFilter = adapterFilters(tableFilter);
            }

            if (!url && table.url) {
                url = table.url;
            }
            let tableData;
            if (pagination === true) {
                tableData = await this.fetcher({
                    baseURL: baseURL,
                    url,
                    method,
                    query: {
                        query: tableFilter,
                        rows,
                        page,
                        ...queryParams,
                    },
                    ...fetch,
                });
            } else {
                tableData = await this.fetcher({
                    baseURL: baseURL,
                    url,
                    method,
                    query: {
                        query: tableFilter,
                        ...queryParams,
                    },
                    ...fetch,
                });
            }

            if (adapterData && typeof adapterData === "function") {
                tableData = await adapterData(tableData);
            }

            if (customFields) {
                // Add custom fields to table data
                
                const newData = getValueByPath(tableData, matchResponse).map(
                    (item, index) => {
                        return {
                            ...item,
                            ...customFields,
                        };
                    }
                );

                setValueByPath(tableData, matchResponse, newData);
            }
            if (getValueByPath(tableData, matchResponsePages)) {
                table["total_pages"] = getValueByPath(tableData, matchResponsePages); // Set new total pages
            }
            if (table.tempItems) {
                table.tempItems = this.normalizeArrayData({
                    data: getValueByPath(tableData, matchResponse),
                });
            }

            table.items = this.normalizeArrayData({
                data: getValueByPath(tableData, matchResponse),
            });

            if (table.itemsFiltered) {
                table.itemsFiltered = table.items;
            }

            return table;
        },

        getTableFieldsFromFirstItem({ tableName }) {
            let headers = [];
            if (this.tables[tableName].items.length > 0) {
                for (const key in this.tables[tableName].items[0]) {
                    headers.push(key);
                }
            }
            return headers;
        },

        getStoreTable(tableName) {
            if (!this.storePageTables) {
                throw new Error("Store tables not found");
            }
            let find = this.storePageTables.find(
                (table) => table.name === tableName
            );
            if (!find) {
                throw new Error("Table not found");
            }
            return find;
        },

        getStoreTableFields(tableName) {
            return this.getStoreTable(tableName).allFields;
        },

        toggleDetails(tableName, index) {
            let item = this.tables[tableName].items[index];
            this.$set(
                this.tables[tableName].items[index],
                "_toggled",
                !item._toggled
            );
        },

        adapterFiltersToUseDate(query) {
            query = new QueryBuilder(query);
            query.createdAtToDate();
            return query.getQuery();
        },
    },
};
